import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { OpenModal, closeModal, setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import moment from "moment";
import DatePicker from "react-date-picker";
// import Modal from "../../Services/Modal";
// import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import TimePicker from "react-time-picker";
import { setToastData } from "../../Store/reducers/Toast";
import { ConvertErrorArrayToString, integerTest } from "../../Services/Common";
import AsyncSelect from 'react-select/async';
import { EVENT_TYPE_OPTIONS } from "./constants";
const EditEvent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [eventData, setEventData] = useState({});
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [allMembers, setAllMembers] = useState([]);
    const [adminAllMembers, setAdminAllMembers] = useState({});
    // const [mapPopup, setmapPopup] = useState(false);
    const [formDivList, setDivisionList] = useState([{ div_id: 0, div_cap: 0,register_members: [] }]);
    // const [markerPosition, setMarkerPosition] = useState({
    //     lat: 22.6963089,
    //     lng: 75.8573989
    // });
    useEffect(() => {
        if (!location.state?.event_id || location.state?.event_id < 1) {
            navigate('/events');
        }
        else {
            dispatch(setMainLoading(true));
            dispatch(setPageTitle('Update Event'));
            PostAxios(`event/view-event-by-id`, { event_id: location.state.event_id }, accessToken)
                .then(({ data }) => {
                    if (data.status === "1") {
                        // setMarkerPosition({
                        //     lat: parseFloat(data.data.event_lat),
                        //     lng: parseFloat(data.data.event_lng)
                        // });
                        let tempDivList = [];
                        let eventDivs = (data.data.event_user_div).split(',');
                        let eventDivsCaps = (data.data.event_div_cap).split(',');
                        if (eventDivs.length > 0) {
                            for (let ed in eventDivs) {
                                let divMemsFilter = data.membersList.filter(mem => parseInt(mem.user_div) === parseInt(eventDivs[ed]));
                                console.log(divMemsFilter,data.membersList);
                                tempDivList.push({ div_id: eventDivs[ed], div_cap: eventDivsCaps[ed], register_members: divMemsFilter?.map((item) => { return { label: `${item.full_name} (${item.user_its})`, value: item.user_id } }) })
                            }
                        }
                        setDivisionList(tempDivList);
                        fetchOrgDivList({ ...data.data, membersList: data.membersList });
                    }
                    else {
                        navigate('/events');
                    }
                })
                .catch(err => {
                    responseCatchFunc(dispatch, err);
                }).finally(() => {

                })
        }
    }, [location]);
    const fetchOrgDivList = (memData) => {
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                    setEventData(memData);
                })
                .catch(err => {
                    console.log(err);
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
        else {
            setEventData(memData);
            dispatch(setMainLoading(false));
        }
    }
    const filteredDivList = (org_id) => {
        let tempL = [];
        let orgId = parseInt(org_id);
        for (let div of divList) {
            if (parseInt(div.org_id) === orgId || orgId === 0) {
                tempL.push(div);
            }
        }
        return tempL;
    }
    const FormikTimePicker = ({ field, form, ...props }) => {
        const { name, value } = field;
        const { setFieldValue } = form;

        return (
            <TimePicker
                {...field}
                {...props}
                onChange={val => setFieldValue(name, val)}
                value={value}
            />
        );
    };
    const fetchMembersList = async (inputValue, ChoosenDiv_id = 0) => {
        /*return new Promise((resolve, reject) => {
            PostAxios(`users`, {
                org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
                div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div,
                page: 0,
                perPage: 1000,
                search: inputValue
            }, accessToken)
                .then(({ data }) => {
                    let memList = [];
                    if (data.status === "1" && data?.data?.length > 0) {
                        for (let i of data.data) {
                            memList.push({
                                value: i.id,
                                label: `${i.full_name} (${i.user_its})`
                            })
                        }
                    }
                    resolve(memList);
                })
                .catch((err) => {
                    responseCatchFunc(dispatch, err)
                })
        })*/
        let div_id = (ChoosenDiv_id === "all") ? (userData.role_slug === "super_admin" ? 0 : userData.user_div) : ChoosenDiv_id;
        return new Promise((resolve, reject) => {
            PostAxios(`users`, {
                org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
                div_id: div_id,
                page: 0,
                perPage: 1000,
                search: inputValue
            }, accessToken)
                .then(({ data }) => {
                    let memList = [];
                    if (data.status === "1" && data?.data?.length > 0) {
                        for (let i of data.data) {
                            memList.push({
                                value: i.id,
                                label: `${i.full_name} (${i.user_its})`
                            })
                        }
                    }
                    resolve(memList);
                })
                .catch((err) => {
                    responseCatchFunc(dispatch, err)
                    return [];
                })
        })
    }
    // const onMapClick = useCallback((event) => {
    //     setMarkerPosition({
    //         lat: event.latLng.lat(),
    //         lng: event.latLng.lng()
    //     });
    // }, []);
    if (typeof eventData.event_title !== "undefined") {
        return (
            <div className="main-form-sec">
                <Formik
                    initialValues={{
                        org_id: eventData.event_organization,
                        div_id: (parseInt(eventData.event_user_div) === 0) ? [0] : (eventData.event_user_div).split(','),
                        event_title: eventData.event_title,
                        event_start_date: eventData.event_start_date,
                        event_end_date: eventData.event_end_date,
                        event_start_time: eventData.event_start_time,
                        event_end_time: eventData.event_end_time,
                        registration_start_date: '',//eventData.registration_start_date === "0000-00-00 00:00:00" ? new Date() : eventData.registration_start_date,
                        registration_end_date: '',//eventData.registration_end_date === "0000-00-00 00:00:00" ? new Date() : eventData.registration_end_date,
                        event_description: eventData.event_description,
                        event_location: eventData.event_location,
                        // event_lat: eventData.event_lat,
                        // event_lng: eventData.event_lng,
                        // event_radius: eventData.event_radius,
                        attendence_time: eventData.attendence_time,
                        div_cap: (eventData.event_div_cap).split(','),
                        div_list: formDivList,
                        event_admin: { value: eventData.event_admin, label: eventData.event_admin_name },
                        event_incharge: { value: eventData.event_incharge, label: eventData.event_incharge_name },
                        register_members: userData.role_slug === "super_admin" || userData.role_slug === "org_admin" ? [] : eventData?.membersList?.map((item) => { return { label: `${item.full_name} (${item.user_its})`, value: item.user_id } }),
                        event_type: eventData.event_type || "local",
                    }}
                    validate={values => {
                        const errors = {};
                        if (parseInt(values.org_id) < 1) { errors.org_id = "Organization ID should not be empty"; }
                        /*if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
                            if (!values.div_list || !values.div_list.length) {
                                errors.div_list = [{ div_id: 'Mohallah is required', div_cap: 'Cap is required' }];
                            }
                            else {
                                errors.div_list = values.div_list.map((item) => ({
                                    div_id: parseInt(item.div_id) > 0 || item.div_id === "all" ? '' : 'Mohallah is required',
                                    div_cap: (parseInt(item.div_cap) > 0 && integerTest(item.div_cap)) ? '' : 'Cap is required'
                                }));
                            }
                            const hasErrors = Object.values(errors.div_list).some((itemErrors) => Object.values(itemErrors).some((error) => !!error));
                            if (hasErrors === false) delete errors.div_list;
                        }*/
                        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
                            if (!values.div_list || !values.div_list.length) {
                                errors.div_list = [{ div_id: 'Mohallah is required', div_cap: 'Cap is required', register_members: 'Please select or specific members' }];
                            }
                            else {
                                errors.div_list = values.div_list.map((item) => ({
                                    div_id: parseInt(item.div_id) > 0 || item.div_id === "all" ? '' : 'Mohallah is required',
                                    div_cap: '',
                                    register_members: item.register_members.length > 0 ? '' : 'Please select or specific members'
                                }));
                            }
                            const hasErrors = Object.values(errors.div_list).some((itemErrors) => Object.values(itemErrors).some((error) => !!error));
                            if (hasErrors === false) delete errors.div_list;
                        }
                        // if (parseInt(values.div_id) < 1) { errors.div_id = "Please choose Mohallah of Member"; }
                        if (!values.event_title) { errors.event_title = "Event Title should not be empty"; }
                        if (!values.event_start_date) { errors.event_start_date = "Please choose event start date"; }
                        if (!values.event_end_date) { errors.event_end_date = "Please choose event end date"; }
                        if (!values.event_start_time) { errors.event_start_time = "Please choose event start time"; }
                        if (!values.event_end_time) { errors.event_end_time = "Please choose event end time"; }
                        // if (!values.registration_start_date) { errors.registration_start_date = "Please choose registration start date"; }
                        // if (!values.registration_end_date) { errors.registration_end_date = "Please choose registration end date"; }
                        if (!values.event_description) { errors.event_description = "Please choose event description"; }
                        if (!values.event_location) { errors.event_location = "Please choose location of event"; }
                        if ((userData.role_slug === "super_admin" || userData.role_slug === "org_admin") && !values.event_type) { errors.event_type = "Please choose event type"; }
                        // if (!values.event_lat) { errors.event_lat = "Latitude should not be empty"; }
                        // if (!values.event_lng) { errors.event_lng = "Longitude should not be empty"; }
                        // if (!values.event_radius) { errors.event_radius = "Please enter event radius"; }
                        // else if (!integerTest(values.event_radius)) { errors.event_radius = "Radius should be in integers only"; }
                        if (!values.event_admin && values.event_admin < 1) { errors.event_admin = "Please choose Event Admin"; }
                        if (!values.event_incharge && values.event_incharge < 1) { errors.event_incharge = "Please choose Event Incharge"; }
                        if (!values.attendence_time) { errors.attendence_time = "Please choose attendance ending time"; }
                        if (!values.register_members) { errors.register_members = "Please choose members"; }
                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        let extractDivs = [];
                        let extractDivCaps = [];
                        let div_id = values.div_id;
                        let regMems = values.register_members.map((item) => item.value);
                        let postData = {
                            event_organization: values.org_id,
                            event_user_div: div_id.join(','),
                            event_title: values.event_title,
                            event_start_date: values.event_start_date,
                            event_end_date: values.event_end_date,
                            event_start_time: `${values.event_start_time}:00`,
                            event_end_time: `${values.event_end_time}:00`,
                            // registration_start_date: values.registration_start_date,
                            // registration_end_date: values.registration_end_date,
                            event_description: values.event_description,
                            event_location: values.event_location,
                            event_type: (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") ? values.event_type : "local",
                            event_incharge: values.event_incharge?.value,
                            event_admin: values.event_admin?.value,
                            // event_lat: values.event_lat,
                            // event_lng: values.event_lng,
                            // event_radius: values.event_radius,
                            attendence_time: `${values.attendence_time}:00`,
                            register_members: regMems
                        }
                        /*if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
                            if (values.div_list.length > 0) {
                                values.div_list.map((item) => {
                                    extractDivs.push(item.div_id)
                                    extractDivCaps.push(item.div_cap)
                                });
                                postData.event_user_div = extractDivs;//.join(',');
                                postData.event_div_cap = extractDivCaps;//.join(',');
                            }
                        }*/
                        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
                            if (values.div_list.length > 0) {
                                let eventDivMemsList = [];
                                values.div_list.map((item) => {
                                    extractDivs.push(item.div_id);
                                    eventDivMemsList.push({
                                        div_id: item.div_id,
                                        div_cap: item.div_cap,
                                        regMems: item.register_members.map((rmItem) => rmItem.value),
                                    })
                                });
                                postData.event_user_div = extractDivs.join(',');
                                postData.eventDivMemsList = eventDivMemsList;
                            }
                        }
                        dispatch(setMainLoading(true));
                        setSubmitting(true);
                        PostAxios(`event/edit-event`, { event_id: eventData.ID, ...postData }, accessToken)
                            .then(({ data }) => {
                                if (data.status === "1") {
                                    dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
                                    navigate('/events')
                                }
                                else {
                                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                                }
                            })
                            .catch(err => {
                                responseCatchFunc(dispatch, err);
                            })
                            .finally(() => {
                                dispatch(setMainLoading(false));
                                setSubmitting(false);
                            })
                    }}
                    enableReinitialize
                >
                    {({ errors, touched, isSubmitting, handleChange, setFieldValue, values }) => (
                        <Form>
                            <div className="form-sec">
                                {
                                    userData.role_slug === "super_admin" &&
                                    <div className={`form-field-group w-50 ${(errors.org_id && touched.org_id) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="org_id">Organization</label>
                                        </div>
                                        <div className="w-50">
                                            <label className="select-input-outer select-100">
                                                <Field name="org_id" as="select" className="select-input" onChange={(e) => {
                                                    if (e.target.value === "0") {
                                                        setFieldValue('div_id', 0);
                                                    }
                                                    handleChange(e)
                                                }}>
                                                    <option value="0">Choose Organization</option>
                                                    {
                                                        orgList.length > 0 && orgList.map((item, index) => {
                                                            return <option value={item.ID} key={`org-list-${item.ID}`}>{item.short_name}</option>
                                                        })
                                                    }
                                                </Field>
                                            </label>
                                            <ErrorMessage component="span" name="org_id" className="error-label" />
                                        </div>
                                    </div>
                                }
                                <div className={`form-field-group w-50 ${(errors.event_title && touched.event_title) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_title">Event Title*</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field type="text" className="form-input" placeholder="Event Title" name='event_title' />
                                        <ErrorMessage component="span" name="event_title" className="error-label" />
                                    </div>
                                </div>
                                {
                                    (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                    <div className={`form-field-group w-50 ${(errors.event_type && touched.event_type) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="event_type">Event Type*</label>
                                        </div>
                                        <div className="w-50">
                                            <label className="select-input-outer select-100">
                                                <Field
                                                    name="event_type"
                                                    as="select"
                                                    className="select-input"
                                                >
                                                    {
                                                        EVENT_TYPE_OPTIONS.map((option) => (
                                                            <option key={`event-type-${option.value}`} value={option.value}>{option.label}</option>
                                                        ))
                                                    }
                                                </Field>
                                            </label>
                                            <ErrorMessage component="span" name="event_type" className="error-label" />
                                        </div>
                                    </div>
                                }
                                <div className={`form-field-group w-50 ${(errors.event_description && touched.event_description) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_description">Description</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field as="textarea" className="form-input form-textarea" placeholder="Description" name='event_description' rows={5} />
                                        <ErrorMessage component="span" name="event_description" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_start_date && touched.event_start_date) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_start_date">Event Start Date*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <DatePicker
                                                className="form-input"
                                                placeholder="Start Date"
                                                name={`event_start_date`}
                                                id={`event_start_date`}
                                                clearIcon={null}
                                                minDate={new Date()}
                                                format="dd-MM-y"
                                                dayPlaceholder="DD"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="YYYY"
                                                onChange={(val) => {
                                                    if (val) {
                                                        setFieldValue(`event_start_date`, moment(val).format("YYYY-MM-DD"))
                                                    }
                                                }}
                                                value={(values.event_start_date && new Date(values.event_start_date)) || null}
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="event_start_date" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_end_date && touched.event_end_date) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_end_date">Event Start Date*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <DatePicker
                                                className="form-input"
                                                placeholder="Start Date"
                                                name={`event_end_date`}
                                                id={`event_end_date`}
                                                clearIcon={null}
                                                minDate={new Date(values.event_start_date)}
                                                format="dd-MM-y"
                                                dayPlaceholder="DD"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="YYYY"
                                                onChange={(val) => {
                                                    if (val) {
                                                        setFieldValue(`event_end_date`, moment(val).format("YYYY-MM-DD"))
                                                    }
                                                }}
                                                value={(values.event_end_date && new Date(values.event_end_date)) || null}
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="event_end_date" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_start_time && touched.event_start_time) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_start_time">Event Start Time*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <Field component={FormikTimePicker}
                                                className="form-input"
                                                placeholder="Start Time"
                                                name={`event_start_time`}
                                                id={`event_start_time`}
                                                clockIcon={null}
                                                disableClock={true}
                                                clearIcon={null}
                                                hourPlaceholder="HH"
                                                minutePlaceholder="mm"
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="event_start_time" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_end_time && touched.event_end_time) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_end_time">Event End Time*</label>
                                    </div>
                                    <div className="w-50">
                                        <Field component={FormikTimePicker}
                                            className="form-input"
                                            placeholder="End Time"
                                            name={`event_end_time`}
                                            id={`event_end_time`}
                                            clockIcon={null}
                                            disableClock={true}
                                            clearIcon={null}
                                            hourPlaceholder="HH"
                                            minutePlaceholder="mm"
                                        />
                                        <ErrorMessage component="span" name="event_end_time" className="error-label" />
                                    </div>
                                </div>
                                {/* <div className={`form-field-group w-50 ${(errors.registration_start_date && touched.registration_start_date) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="registration_start_date">Registration Start Date*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <DatePicker
                                                className="form-input"
                                                placeholder="Registration Start Date"
                                                name={`registration_start_date`}
                                                id={`registration_start_date`}
                                                clearIcon={null}
                                                minDate={new Date()}
                                                format="dd-MM-y"
                                                dayPlaceholder="DD"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="YYYY"
                                                onChange={(val) => {
                                                    if (val) {
                                                        setFieldValue(`registration_start_date`, moment(val).format("YYYY-MM-DD"))
                                                    }
                                                }}
                                                value={(values.registration_start_date && new Date(values.registration_start_date)) || null}
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="registration_start_date" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.registration_end_date && touched.registration_end_date) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="registration_end_date">Registration End Date*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <DatePicker
                                                className="form-input"
                                                placeholder="Registration End Date"
                                                name={`registration_end_date`}
                                                id={`registration_end_date`}
                                                clearIcon={null}
                                                minDate={new Date(values.registration_start_date)}
                                                format="dd-MM-y"
                                                dayPlaceholder="DD"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="YYYY"
                                                onChange={(val) => {
                                                    if (val) {
                                                        setFieldValue(`registration_end_date`, moment(val).format("YYYY-MM-DD"))
                                                    }
                                                }}
                                                value={(values.registration_end_date && new Date(values.registration_end_date)) || null}
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="registration_end_date" className="error-label" />
                                    </div>
                                </div> */}
                                <div className={`form-field-group w-50 ${(errors.event_location && touched.event_location) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_location">Event Location*</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field type="text" className="form-input" placeholder="Event Location" name='event_location' />
                                        <ErrorMessage component="span" name="event_location" className="error-label" />
                                    </div>
                                </div>
                                {/*
                                <div className={`form-field-group w-50 ${(errors.event_radius && touched.event_radius) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_radius">Event Radius*</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field type="text" className="form-input" placeholder="Event Radius" name='event_radius' />
                                        <ErrorMessage component="span" name="event_radius" className="error-label" />
                                        <span>In Meters</span>
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_lat && touched.event_lat) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_lat">Event Latitude*</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field type="text" className="form-input" placeholder="Event Latitude" name='event_lat' />
                                        <ErrorMessage component="span" name="event_lat" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_lng && touched.event_lng) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_lng">Event Longitude*</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field type="text" className="form-input" placeholder="Event Longitude" name='event_lng' />
                                        <ErrorMessage component="span" name="event_lng" className="error-label" />
                                    </div>
                                </div>
                                <div className="form-field-group w-100">
                                    <button className="btn btn-blue" type="button" onClick={() => {
                                        setmapPopup(true);
                                        dispatch(OpenModal());
                                    }}><i className="fa-solid fa-location-dot me-3"></i>Choose from Map</button>
                                </div>
                                    */}

                                <div className={`form-field-group w-50 ${(errors.attendence_time && touched.attendence_time) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="attendence_time">Event Attendance End Time*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <Field component={FormikTimePicker}
                                                className="form-input"
                                                placeholder="Start Time"
                                                name={`attendence_time`}
                                                id={`attendence_time`}
                                                clockIcon={null}
                                                disableClock={true}
                                                clearIcon={null}
                                                hourPlaceholder="HH"
                                                minutePlaceholder="mm"
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="attendence_time" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_incharge && touched.event_incharge) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_incharge">Event Incharge*</label>
                                    </div>
                                    <div className="w-50 input-area text-left">
                                        <AsyncSelect
                                            //options={membersList}
                                            placeholder="Choose Event Incharge"
                                            value={values.event_incharge}
                                            onChange={(values) => {
                                                setFieldValue('event_incharge', values);
                                            }}
                                            cacheOptions
                                            defaultOptions
                                            isSearchable={true}
                                            loadOptions={async (e) => {
                                                let fetchmems = await fetchMembersList(e, values.div_id[0]);
                                                return fetchmems;
                                            }}
                                            isMulti={false}
                                        />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.event_admin && touched.event_admin) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="event_admin">Event Admin*</label>
                                    </div>
                                    <div className="w-50 input-area text-left">
                                        <Field name="event_admin">
                                            {({ field }) => (
                                                <AsyncSelect
                                                    //options={membersList}
                                                    placeholder="Choose Event Admin"
                                                    value={values.event_admin}
                                                    onChange={(values) => {
                                                        setFieldValue('event_admin', values);
                                                    }}
                                                    cacheOptions
                                                    defaultOptions
                                                    isSearchable={true}
                                                    loadOptions={async (e) => {
                                                        let fetchmems = await fetchMembersList(e, values.div_id[0]);
                                                        return fetchmems;
                                                    }}
                                                    isMulti={false}
                                                />
                                            )}
                                        </Field>

                                    </div>
                                </div>
                                {
                                    (userData.role_slug !== "super_admin" && userData.role_slug !== "org_admin") &&
                                    <>
                                        <div className="divider"></div>
                                        <div className={`form-field-group w-50 ${(errors.register_members && touched.register_members) ? 'error-input' : ''}`}>
                                            <div className="w-50">
                                                <label htmlFor="event_admin">Event Members*</label>
                                            </div>
                                            <div className="w-50 input-area text-left">
                                                <AsyncSelect
                                                    //options={membersList}
                                                    placeholder="Choose Members"
                                                    value={values.register_members}
                                                    onChange={(selectedOptions) => {
                                                        if (selectedOptions.some((option) => option.value === "select_all")) {
                                                            setFieldValue("register_members", allMembers);
                                                        } else {
                                                            setFieldValue("register_members", selectedOptions);
                                                        }
                                                    }}
                                                    styles={{
                                                        valueContainer: (base) => ({
                                                            ...base,
                                                            display: 'inline-block',
                                                            maxHeight: 150,
                                                            overflow: 'auto'
                                                        }),
                                                    }}
                                                    cacheOptions
                                                    defaultOptions
                                                    isSearchable={true}
                                                    loadOptions={async (e) => {
                                                        let fetchmems = await fetchMembersList(e, values.div_id[0]);
                                                        setAllMembers(fetchmems);
                                                        return [{ label: "Select All", value: "select_all" }, ...fetchmems];
                                                    }}
                                                    isMulti={true}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                                {(userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                    <>
                                        <div className="divider"></div>
                                        <FieldArray
                                            name="div_list"
                                            render={arrayHelpers => {
                                                const selectedDivisions = values.div_list.map(item => item.div_id);
                                                return (
                                                    <div className={`location-impacted-main w-100`}>
                                                        {
                                                            values.div_list.map((fa, index) => (
                                                                <div className="form-field-group w-100" key={index}>
                                                                    <div className={`location-impacted ${(errors.div_list?.[index]?.div_id && touched.div_list?.[index]?.div_id) ? 'error-input' : ''}`}>
                                                                        <label htmlFor="">Mohallah*:</label>
                                                                        <Field
                                                                            as="select"
                                                                            className="select-input"
                                                                            name={`div_list.${index}.div_id`}
                                                                            onChange={async (e) => {
                                                                                const value = e.target.value;
                                                                                setFieldValue(`div_list.${index}.div_id`, value);

                                                                                // Clear the selected members when the division changes
                                                                                setFieldValue(`div_list.${index}.register_members`, []);

                                                                                // Fetch and store new members based on selected div_id
                                                                                if (value !== "0" && value !== "") {
                                                                                    const allMembers = await fetchMembersList('', value);
                                                                                    setAdminAllMembers({ ...adminAllMembers, [value]: allMembers });
                                                                                }
                                                                            }}
                                                                        >
                                                                            <option value="0">Choose Mohallah</option>
                                                                            {!values.div_list.some((item) => item.div_id !== "0" && item.div_id !== "all") && parseInt(values.org_id) > 0 && <option value="all">All</option>}
                                                                            {filteredDivList(values.org_id).length > 0 &&
                                                                                filteredDivList(values.org_id)
                                                                                    .filter((item) => {
                                                                                        return (
                                                                                            parseInt(item.org_id) === parseInt(values.org_id) &&
                                                                                            (item.ID === values.div_list[index]?.div_id || !selectedDivisions.includes(item.ID))
                                                                                        );
                                                                                    })
                                                                                    .map((item, idx) => (
                                                                                        <option value={item.ID} key={`div-list-${item.ID}-${idx}`}>
                                                                                            {item.division_name} ({item.division_number})
                                                                                        </option>
                                                                                    ))
                                                                            }
                                                                        </Field>
                                                                        <ErrorMessage component="span" name={`div_list.${index}.div_id`} className="error-label" />
                                                                    </div>

                                                                    <div
                                                                        style={{ maxWidth: 350 }}
                                                                        className={`location-impacted ${(errors.div_list?.[index]?.register_members && touched.div_list?.[index]?.register_members) ? 'error-input' : ''}`}
                                                                    >
                                                                        <label htmlFor="">Choose Members*:</label>
                                                                        <AsyncSelect
                                                                            key={values.div_list[index].div_id} // Add key to re-render on div_id change
                                                                            placeholder="Choose Members"
                                                                            value={values.div_list[index].register_members}
                                                                            onChange={async (selectedValues) => {
                                                                                if (selectedValues.some((option) => option.value === 'select_all')) {
                                                                                    const allMembers = await fetchMembersList('', values.div_list[index].div_id);
                                                                                    setFieldValue(`div_list.${index}.register_members`, allMembers);
                                                                                } else {
                                                                                    setFieldValue(`div_list.${index}.register_members`, selectedValues);
                                                                                }
                                                                            }}
                                                                            cacheOptions
                                                                            defaultOptions
                                                                            isSearchable
                                                                            styles={{
                                                                                valueContainer: (base) => ({
                                                                                    ...base,
                                                                                    maxHeight: 150,
                                                                                    overflow: 'auto',
                                                                                }),
                                                                            }}
                                                                            loadOptions={async (searchedText) => {
                                                                                const selectedDivId = values.div_list?.[index]?.div_id;
                                                                                if (!selectedDivId || selectedDivId === "0") {
                                                                                    return [];
                                                                                }

                                                                                if (selectedDivId) {
                                                                                    const members = await fetchMembersList(searchedText, selectedDivId);
                                                                                    setAdminAllMembers({ ...adminAllMembers, [selectedDivId]: members });
                                                                                    return [{ label: 'Select All', value: 'select_all' }, ...members];
                                                                                }
                                                                                return [];
                                                                            }}
                                                                            isMulti
                                                                        />
                                                                        <ErrorMessage component="span" name={`div_list.${index}.register_members`} className="error-label" />
                                                                    </div>

                                                                    <div className="prc-action-btn">
                                                                        {
                                                                            (values.div_list.length - 1) == index && <button type="button" className="add-icon" onClick={() => arrayHelpers.push({ div_id: 0, div_cap: 0, register_members: [] })} >
                                                                                <i className="fa-solid fa-circle-plus"></i>
                                                                            </button>
                                                                        }
                                                                        {
                                                                            values.div_list.length > 1 &&
                                                                            <button className="remove-icon" type="button" onClick={() => arrayHelpers.remove(index)}>
                                                                                <i className="fa-solid fa-circle-xmark"></i>
                                                                            </button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                )
                                            }}
                                        />
                                    </>
                                }
                                {/* {(userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                    <FieldArray
                                        name="div_list"
                                        render={arrayHelpers => {
                                            return (
                                                <div className={`location-impacted-main w-50`}>
                                                    {
                                                        values.div_list.map((fa, index) => (
                                                            <div className="form-field-group w-100" key={index}>
                                                                <div className={`location-impacted ${(errors.div_list?.[index]?.div_id && touched.div_list?.[index]?.div_id) ? 'error-input' : ''}`}>
                                                                    <label htmlFor="">Mohallah*:</label>
                                                                    <Field as="select" className="select-input" name={`div_list.${index}.div_id`}>
                                                                        <option value="0">Choose Mohallah</option>
                                                                        <option value="all">All</option>
                                                                        {
                                                                            filteredDivList(values.org_id).length > 0 && filteredDivList(values.org_id).map((item, index) => {
                                                                                if (parseInt(item.org_id) === parseInt(values.org_id)) {
                                                                                    return <option value={item.ID} key={`div-list-${item.ID}-${index}`}>{item.division_name} {`(${item.division_number})`}</option>
                                                                                }
                                                                                return null;
                                                                            })
                                                                        }
                                                                    </Field>
                                                                    <ErrorMessage component="span" name={`div_list.${index}.div_id`} className="error-label" />
                                                                </div>
                                                                <div className={`location-impacted ${(errors.div_list?.[index]?.div_cap && touched.div_list?.[index]?.div_cap) ? 'error-input' : ''}`}>
                                                                    <label htmlFor="">Mohallah*:</label>
                                                                    <Field type="text" className="form-input" name={`div_list.${index}.div_cap`}>
                                                                    </Field>
                                                                    <ErrorMessage component="span" name={`div_list.${index}.div_cap`} className="error-label" />
                                                                </div>
                                                                <div className="prc-action-btn">
                                                                    {
                                                                        (values.div_list.length - 1) == index && <button type="button" className="add-icon" onClick={() => arrayHelpers.push({ div_id: 0, div_cap: 0 })} >
                                                                            <i className="fa-solid fa-circle-plus"></i>
                                                                        </button>
                                                                    }
                                                                    {
                                                                        values.div_list.length > 1 &&
                                                                        <button className="remove-icon" type="button" onClick={() => arrayHelpers.remove(index)}>
                                                                            <i className="fa-solid fa-circle-xmark"></i>
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            )
                                        }}
                                    />
                                } */}
                                {/* Submit Button */}
                                <div className="btm-right-btn justify-content-center my-3">
                                    <button className="btn-blue btn" type="submit" disabled={isSubmitting}>Update Event</button>
                                </div>
                            </div>
                            {/* {
                                mapPopup === true && <Modal classList="popup-main invoice-popup" onClose={() => {
                                    setmapPopup(false);
                                }}>
                                    <h3 className="text-center">Choose Latitude & Longitude from map</h3>
                                    <div className="map-wrapper my-3" style={{ width: '100%', height: 350, border: '1px solid #848484', borderRadius: 5 }}>
                                        <LoadScript id="even-location-map" googleMapsApiKey={process.env.REACT_MAP_API_KEY}>
                                            <GoogleMap
                                                mapContainerStyle={{
                                                    width: '100%',
                                                    height: '100%'
                                                }}
                                                zoom={16}
                                                center={markerPosition}
                                                onClick={onMapClick}
                                            >
                                                <Marker position={markerPosition} />
                                            </GoogleMap>
                                        </LoadScript>
                                    </div>
                                    <div className="w-100 my-3 d-flex justify-content-between">
                                        <p>Latitude: {markerPosition.lat}</p>
                                        <p>Longitude: {markerPosition.lng}</p>
                                    </div>
                                    <div className="button-wrapper text-center">
                                        <button type="button" className="btn btn-blue" onClick={() => {
                                            setFieldValue('event_lat', markerPosition.lat);
                                            setFieldValue('event_lng', markerPosition.lng);
                                            dispatch(closeModal());
                                            setmapPopup(false);

                                        }}>Confirm Location</button>
                                    </div>
                                </Modal>
                            } */}
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
    return null;
}

export default EditEvent;